/*
 * @Description:
 * @Date: 2020-08-25 18:58:21
 * @LastEditors: jml
 */

/**
 * 判断是否从首页项目列表进入
 * @param {$route.query} query
 */
const isHomeInto = query => {
  const { home, projectName } = query || {};
  return home && projectName;
};
export default {
  beforeCreate() {
    const query = this.$route.query;
    if (isHomeInto(query)) {
      // 不填充任务月度
      this.noNeedForDate = true;
      this.noNeedInitDate = true;
    }
  },
  created() {
    const query = this.$route.query;
    // 将地址中的projectName 赋值到搜索条件中
    (this.searchQuery || {}).projectName = (query || {}).projectName;
    if ('taskMonth' in query) {
      this.dateValue = (query || {}).taskMonth;
      (this.searchQuery || {}).taskDate = (query || {}).taskMonth;
      (this.searchQuery || {}).dateRange = (query || {}).taskMonth;
      (this.searchQuery || {}).taskDt = (query || {}).taskMonth;
    }
  },
  watch: {
    'searchQuery.projectName': {
      handler(v) {
        if (!v) {
          // 清空了项目名称
          // 清空地址中的projectName和home字段
          let { query = {} } = this.$route;
          if (isHomeInto(query)) {
            delete query.projectName;
            delete query.home;
            this.$router.replace({
              ...this.$route,
              query
            });
          }
        }
      }
    }
  }
};
